import { render } from "./ImageUpload.vue?vue&type=template&id=3803ad8e&scoped=true"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"

import "./ImageUpload.vue?vue&type=style&index=0&id=3803ad8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3803ad8e"]])

export default __exports__